"use client";

import { SkeletonBlock, SkeletonText } from "@zapier/design-system";
import styles from "./SearchDropdown.module.css";

interface AssetSearchSkeletonProps {
  count?: number;
}

export function AssetSearchSkeleton({ count = 3 }: AssetSearchSkeletonProps) {
  return (
    <div className={styles.assetSkeleton}>
      {Array.from({ length: count }).map((_, index) => (
        <div key={index} className={styles.assetSkeletonRow}>
          <SkeletonBlock height={16} width={16} borderRadius="medium" />
          <SkeletonText lines={1} />
        </div>
      ))}
    </div>
  );
}
